module.exports = __webpack_public_path__ + "static/media/card-MasterCard-mobile.9cbff5ac.svg";